// src/components/layout/DriverLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';

const DriverLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm p-4">
        <h1 className="text-xl font-bold">Driver Portal</h1>
      </div>
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default DriverLayout;